import { VariantService } from "./../../../services/catalogs/VariantService";
import { VariantDetail } from "../../../components/Pages/Catalogs/Variant/VariantDetail";
import { CreateVariantDto } from "../../../dtos/catalogs/variant/CreateVariantDto";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupVariant } from "../../../components/Shared/NewForms/NFLookupVariant";
import VariantList from "../../../components/Pages/Catalogs/Variant/VariantList";

export const Variant: IAppEntity = {
  entityType: "catalog",
  title: "Variant",
  pluralTitle: "Variant",
  apiUrl: "variants",
  apiEnum: ReferenceTypes.CatalogVariant,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(VariantDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VariantList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVariant, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new VariantService(this.apiUrl);
  },
  getEmptyModel(): CreateVariantDto {
    return {
      name: "",
    };
  },
};
